import React from 'react';
import Menu from '@/components/Dashboard/menu';
import Apps from '@/components/Dashboard/stable_app';
import { withRouter, Page } from '@souche-f2e/muji';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import styles from './index.module.less';

@withRouter
class AppManages extends React.Component {
  constructor() {
    super();
  }

  componentWillMount() {
    dispatch.user.LOAD_USER();
    dispatch.user.userinfo();
  }

  render() {
    let { user, isLogin } = this.props;

    user = user || {};

    const stableInfo = user.stableInfo || {};

    const appList = stableInfo.appList;

    // 检查 login 状态
    if(isLogin === false) {
      this.props.router.push('/signIn');
    }

    return <div className={styles.detail}>
      <Menu />
      <Apps apps={appList} />
    </div>
  }
}

const mapStateToProps = (state, ownProps) => {
  const user = state.user;
  return {
    hasUserInfoCache: user.hasUserInfoCache,
    user: user.user,
    isLogin: user.isLogin
  }
}

export default connect(mapStateToProps)(AppManages);